import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { IconProps } from '../../primitives/types.js';

/** Link / chain — two interlocked rings that gently separate + reunite,
 *  suggesting a hyperlink connecting two resources. */
export function IcnLink(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  return (
    <Svg {...props} iconName="link">
      {/* Left ring — drifts a hair left and back */}
      <g>
        {animate && (
          <animateTransform
            attributeName="transform"
            type="translate"
            values="0 0;-0.5 0;0 0;0 0"
            keyTimes="0;0.4;0.7;1"
            dur="2.6s"
            repeatCount="indefinite"
          />
        )}
        <path d="M7 4.5a3 3 0 0 0 -3 3v1a3 3 0 0 0 3 3h1" />
      </g>
      {/* Right ring — mirrored drift */}
      <g>
        {animate && (
          <animateTransform
            attributeName="transform"
            type="translate"
            values="0 0;0.5 0;0 0;0 0"
            keyTimes="0;0.4;0.7;1"
            dur="2.6s"
            repeatCount="indefinite"
          />
        )}
        <path d="M9 4.5h1a3 3 0 0 1 3 3v1a3 3 0 0 1 -3 3h-1" />
      </g>
      {/* Cross-bar glues them together */}
      <line x1="5.5" y1="8" x2="10.5" y2="8" />
    </Svg>
  );
}
